import dayjs from 'dayjs';
import Labs from '../../../../assets/patientcharts/akar-icons_dashboard.png';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';



export const PriorCardsList = ({ x,setselectedProcedure, setIsProcedureDocumentOpen}) => {
  if (!x) return null; // safety check

    const rawDate = x.createddate || x.createddatetime;
  const formattedDate = rawDate && dayjs(rawDate).isValid()
    ? dayjs(rawDate).format('MMMM D, YYYY') // e.g., August 8, 2023
    : '-';

  const description = x.documentdescription || '-';

  return (
    <div className="flex flex-col sm:flex-row justify-between min-h-[38px] items-center w-full max-w-[910px] p-[28px] rounded-[12px] border border-[#232323] border-opacity-10 bg-[#FFF]">
      <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto gap-4 sm:gap-20">
        <div className="flex items-center gap-4">
          {/* Vertical Line */}
          <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 68" fill="none">
            <path d="M1 0V68" stroke="#B8DAFF" />
          </svg>

          {/* Clock Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM15 10C15 10.1658 14.9342 10.3247 14.8169 10.4419C14.6997 10.5592 14.5408 10.625 14.375 10.625H10C9.83424 10.625 9.67527 10.5592 9.55806 10.4419C9.44085 10.3247 9.375 10.1658 9.375 10V5.625C9.375 5.45924 9.44085 5.30027 9.55806 5.18306C9.67527 5.06585 9.83424 5 10 5C10.1658 5 10.3247 5.06585 10.4419 5.18306C10.5592 5.30027 10.625 5.45924 10.625 5.625V9.375H14.375C14.5408 9.375 14.6997 9.44085 14.8169 9.55806C14.9342 9.67527 15 9.83424 15 10Z"
              fill="#232323"
            />
          </svg>

          {/* Formatted Date */}
          <div className="text-[#232323] font-inter text-[16px] font-normal leading-[20px]">
            {formattedDate}
          </div>
        </div>

        {/* Document Description */}
        <div className="text-[#232323] font-inter text-[16px] font-normal leading-[20px] flex-grow capitalize">
          {description}
        </div>
      </div>

      {/* View Button */}
      <div onClick={()=>{setselectedProcedure(x)
       setIsProcedureDocumentOpen(true)
      }} className="text-[#1D2951] text-center font-inter text-[13px] font-light mt-4 sm:mt-0 ml-auto flex items-center cursor-pointer hover:underline">
        <RemoveRedEyeIcon style={{ width: '40px', height: '25px' }} />
        View Document
      </div>
    </div>
  );
};
export const PriorCardsGrid = ({ year, docs = [],setselectedProcedure, setIsProcedureDocumentOpen }) => {
  // docs defaults to [] if undefined
  const sortedDocs = docs.slice().sort((a, b) => {
    const getDate = (d) =>
      dayjs(
        d?.date ||
          d?.created_at ||
          d?.updated_at ||
          d?.encounter_date ||
          d?.createddate ||
          d?.createddatetime ||
          d?.lastmodifieddatetime
      );
    return getDate(b).valueOf() - getDate(a).valueOf();
  });

  if (!sortedDocs.length) {
    return (
      <div className="w-full h-[312px] flex items-center justify-center bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]">
        <span className="text-gray-500">No documents for {year}</span>
      </div>
    );
  }

  return (
    <div className="w-full h-[312px] flex flex-col items-start justify-start p-6 bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]">
      <div className="flex items-center mb-2 mx-1.5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M17 14.5C17.2652 14.5 17.5196 14.3946 17.7071 14.2071C17.8946 14.0196 18 13.7652 18 13.5C18 13.2348 17.8946 12.9804 17.7071 12.7929C17.5196 12.6054 17.2652 12.5 17 12.5C16.7348 12.5 16.4804 12.6054 16.2929 12.7929C16.1054 12.9804 16 13.2348 16 13.5C16 13.7652 16.1054 14.0196 16.2929 14.2071C16.4804 14.3946 16.7348 14.5 17 14.5ZM17 18.5C17.2652 18.5 17.5196 18.3946 17.7071 18.2071C17.8946 18.0196 18 17.7652 18 17.5C18 17.2348 17.8946 16.9804 17.7071 16.7929C17.5196 16.6054 17.2652 16.5 17 16.5C16.7348 16.5 16.4804 16.6054 16.2929 16.7929C16.1054 16.9804 16 17.2348 16 17.5C16 17.7652 16.1054 18.0196 16.2929 18.2071C16.4804 18.3946 16.7348 18.5 17 18.5Z"
            fill="#1D2951"
          />
        </svg>
        <span className="ml-2 font-bold text-[#1d2951] text-base">{year}</span>
      </div>

      <div className="w-full flex flex-col justify-center items-start overflow-y-auto">
        <ul className="w-full space-y-3">
          {sortedDocs.map((doc, i) => {
            const displayDate = dayjs(
              doc?.date ||
                doc?.created_at ||
                doc?.updated_at ||
                doc?.encounter_date ||
                doc?.createddate ||
                doc?.createddatetime ||
                doc?.lastmodifieddatetime
            ).format("MMMM D, YYYY");

            return (
              <li
                key={i}
                className="flex justify-between items-center border-b border-gray-300 pb-2"
              >
                <div className="text-[#1d2951] text-[13px]">{displayDate}</div>
                <div onClick={()=>{setselectedProcedure(doc)
       setIsProcedureDocumentOpen(true)
      }} className="flex items-center text-[#1d2951] text-[13px]">
                  <RemoveRedEyeIcon style={{ width: "40px", height: "25px" }} />
                  Encounter From
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

  
  